import styled from 'styled-components';
import PropTypes from 'prop-types';

// SVG Icons - Keep in alphabetical order
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as AirBalloon,
} from '../assets/svgIcons/airBalloon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ArrowUp,
} from '../assets/svgIcons/arrowUp.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as AutoSaveSafe,
} from '../assets/svgIcons/autoSaveSafe.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Bank,
} from '../assets/svgIcons/bank.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BeggingHandCoin,
} from '../assets/svgIcons/beggingHandCoin.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BookOutline,
} from '../assets/svgIcons/bookOutline.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BrokenLink,
} from '../assets/svgIcons/brokenLink.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Briefcase,
} from '../assets/svgIcons/briefcase.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as BubbleCustom,
} from '../assets/svgIcons/bubble-custom.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Caret,
} from '../assets/svgIcons/caret.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Calculator,
} from '../assets/svgIcons/calculator.svg';
// TODO: Fix Callout question SVG to only use fill
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CalloutQuestion,
} from '../assets/svgIcons/callout-question.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Caution,
} from '../assets/svgIcons/caution.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Certificate,
} from '../assets/svgIcons/certificate.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ChartLineUp,
} from '../assets/svgIcons/chartLineUp.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Checklist,
} from '../assets/svgIcons/checklist.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Check,
} from '../assets/svgIcons/check.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Times,
} from '../assets/svgIcons/times.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Checkmark,
} from '../assets/svgIcons/checkmark.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CheckSmall,
} from '../assets/svgIcons/checkSmall.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CheckNew,
} from '../assets/svgIcons/checkNew.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Cheers,
} from '../assets/svgIcons/cheers.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Close,
} from '../assets/svgIcons/close.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CloseModal,
} from '../assets/svgIcons/closeModal.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CreditCard,
} from '../assets/svgIcons/creditCard.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Cross,
} from '../assets/svgIcons/cross.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Coins,
} from '../assets/svgIcons/coins.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CommonFileTextSearchCustom,
} from '../assets/svgIcons/common-file-text-search-custom.svg';
// TODO: Fix Consultation question SVG to only use fill
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Consultation,
} from '../assets/svgIcons/consultation.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CurrencyDollar,
} from '../assets/svgIcons/currency-dollar.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Document,
} from '../assets/svgIcons/document.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as DollarSign,
} from '../assets/svgIcons/dollarSign.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Email,
} from '../assets/svgIcons/email.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as EmergencyAlarm,
} from '../assets/svgIcons/emergencyAlarm.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ExternalLink,
} from '../assets/svgIcons/external-link.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Family,
} from '../assets/svgIcons/family.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as FileIcon,
} from '../assets/svgIcons/fileIcon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as FileTextUpload,
} from '../assets/svgIcons/fileTextUpload.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as FolderCustom,
} from '../assets/svgIcons/folder-custom.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as FolderWarning,
} from '../assets/svgIcons/icon-folder-warning.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as GearLarge,
} from '../assets/svgIcons/gearLarge.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as GraduationCap,
} from '../assets/svgIcons/graduationCap.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as GraduationCapMinimal,
} from '../assets/svgIcons/graduationCapMinimal.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Graph,
} from '../assets/svgIcons/graph.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Heart,
} from '../assets/svgIcons/heart.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HelpQuestionNetwork,
} from '../assets/svgIcons/helpQuestionNetwork.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HelpWheelCustom,
} from '../assets/svgIcons/help-wheel-custom.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HandCoins,
} from '../assets/svgIcons/handCoins.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HandsHoldingDollar,
} from '../assets/svgIcons/handsHoldingDollar.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HeartHand,
} from '../assets/svgIcons/heartHand.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as InfinitySymbol,
} from '../assets/svgIcons/infinitySymbol.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as InfoIcon,
} from '../assets/svgIcons/infoIcon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Lightbulb,
} from '../assets/svgIcons/lightbulb.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LoanSync,
} from '../assets/svgIcons/loanSync.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LocationPinSimple,
} from '../assets/svgIcons/location-pin.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LocationPin,
} from '../assets/svgIcons/location-pin-icon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as LocationPinError,
} from '../assets/svgIcons/location-pin-error-icon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Lock,
} from '../assets/svgIcons/lock.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as UnlockWithKeyHole,
} from '../assets/svgIcons/unlockWithKeyHole.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MagnifyingGlass,
} from '../assets/svgIcons/magnifying-glass.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MapPin,
} from '../assets/svgIcons/map-pin.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Mask,
} from '../assets/svgIcons/mask.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MoneySignInCircle,
} from '../assets/svgIcons/moneySignInCircle.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as MinusSignOutline,
} from '../assets/svgIcons/minus-sign-outline.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PlusSignOutline,
} from '../assets/svgIcons/plus-sign-outline.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as OpenBook,
} from '../assets/svgIcons/openBook.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as OpenBookOutline,
} from '../assets/svgIcons/openBookOutline.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as OpenExternalPageIcon,
} from '../assets/svgIcons/openExternalPage.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as OverpaymentsIcon,
} from '../assets/svgIcons/overpayments-icon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as pathArrow,
} from '../assets/svgIcons/pathArrow.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PasswordResetKey,
} from '../assets/svgIcons/passwordResetKey.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Pencil,
} from '../assets/svgIcons/pencil.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Pencil2,
} from '../assets/svgIcons/pencil2.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PercentBubble,
} from '../assets/svgIcons/percentBubble.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Phone,
} from '../assets/svgIcons/phone.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PiggyBank,
} from '../assets/svgIcons/piggyBank.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PiggyBankCoins,
} from '../assets/svgIcons/piggyBankCoins.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PiggyBankNew,
} from '../assets/svgIcons/piggy-bank-new.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PiggyBank3,
} from '../assets/svgIcons/piggyBank3.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PresentationBoard,
} from '../assets/svgIcons/presentation-board.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ProtectionShieldStar,
} from '../assets/svgIcons/protection-shield-star.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as QuestionCircle,
} from '../assets/svgIcons/question-circle.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ReceiptViewPricing,
} from '../assets/svgIcons/receiptViewPricing.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as RecruitingEmployeeGraduateMoney,
} from '../assets/svgIcons/recruitingEmployeeGraduateMoney.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SavingBankCash,
} from '../assets/svgIcons/savingBankCash.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SavingsPiggyBank,
} from '../assets/svgIcons/savingsPiggyBank.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SavingSafe,
} from '../assets/svgIcons/savingSafe.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SendEmail,
} from '../assets/svgIcons/SendEmailEnvelope.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ServerCash,
} from '../assets/svgIcons/serverCash.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as ShieldExclamationMark,
} from '../assets/svgIcons/shield-exclamation-mark.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Signature,
} from '../assets/svgIcons/signature.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SlcIcon,
} from '../assets/svgIcons/slc-icon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SortAz,
} from '../assets/svgIcons/sortAz.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SortZa,
} from '../assets/svgIcons/sortZa.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SplitPath,
} from '../assets/svgIcons/splitPath.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as StarIcon,
} from '../assets/svgIcons/star.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as YellowStarIcon,
} from '../assets/svgIcons/star-yellow.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as HalfYellowStarIcon,
} from '../assets/svgIcons/half-star-yellow.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as QuestionCircleOutline,
} from '../assets/svgIcons/question-circle-outline.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as CameraFrame,
} from '../assets/svgIcons/camera-frame.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Rocketship,
} from '../assets/svgIcons/rocketship.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as StopWatch,
} from '../assets/svgIcons/stopWatch.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SummerLogo,
} from '../assets/svgIcons/summerLogo.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SummerLogoSmall,
} from '../assets/svgIcons/summerLogoSmall.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SwimmingPool,
} from '../assets/svgIcons/swimmingPool.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as SyncInfinity,
} from '../assets/svgIcons/syncInfinity.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Target,
} from '../assets/svgIcons/target.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as TargetFlag,
} from '../assets/svgIcons/targetFlag.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as TargetPhone,
} from '../assets/svgIcons/targetPhone.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as TimeMonthly,
} from '../assets/svgIcons/timeMonthly.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Tools,
} from '../assets/svgIcons/tools.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Trash,
} from '../assets/svgIcons/trash.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as TrashNew,
} from '../assets/svgIcons/trashNew.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Verify,
} from '../assets/svgIcons/verify.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as WarningIcon,
} from '../assets/svgIcons/warningIcon.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Website,
} from '../assets/svgIcons/website.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Percentage,
} from '../assets/svgIcons/percentage.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as Pause,
} from '../assets/svgIcons/pause.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PrayingHands,
} from '../assets/svgIcons/praying-hands.svg';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  ReactComponent as PhoneOutline,
} from '../assets/svgIcons/phone-outline.svg';

/**
 * @typedef {Object} IconProps
 * @property {React.ComponentType<React.SVGProps<SVGSVGElement>>} SvgComponent
 * @property {number} [width]
 * @property {number} [height]
 * @property {string} [fill]
 * @property {string} [stroke]
 * @property {string} [hoverFill]
 * @property {string} [hoverStroke]
 * @property {string} [className]
 * @property {React.MouseEventHandler<HTMLDivElement>} [onClick]
 * @property {React.CSSProperties} [style]
 * @property {string} [testId]
 */

/**
 * @param {IconProps} props
 * @returns {React.JSX.Element}
 */
const Icon = ({
  SvgComponent,
  width,
  height,
  fill,
  stroke,
  hoverFill,
  hoverStroke,
  className,
  onClick,
  style,
  testId,
}) => {
  return (
    <StyledIcon
      testId={testId}
      svgWidth={width}
      svgHeight={height}
      fill={fill}
      stroke={stroke}
      hoverFill={hoverFill}
      className={className}
      hoverStroke={hoverStroke}
      onClick={onClick}
      style={style}
    >
      <SvgComponent />
    </StyledIcon>
  );
};

/**
 * @typedef {Object} StyledIconProps
 * @property {number} [svgWidth]
 * @property {number} [svgHeight]
 * @property {string} [fill]
 * @property {string} [stroke]
 * @property {string} [hoverFill]
 * @property {string} [hoverStroke]
 * @property {React.MouseEventHandler<HTMLDivElement>} [onClick]
 * @property {string} [testId]
 */

/** @type {import('styled-components').StyledComponent<'div', any, StyledIconProps>} */
const StyledIcon = styled.div.attrs(props => ({
  'className': 'icon',
  'data-testid': props.testId || 'icon',
}))`
  display: flex;
  justify-content: center;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};

  & svg {
    width: ${({ svgWidth }) =>
      svgWidth ? `${svgWidth}px !important` : 'auto'};
    height: ${({ svgHeight }) =>
      svgHeight ? `${svgHeight}px !important` : 'auto'};
  }

  & path,
  g {
    fill: ${({ fill }) => (fill ? `${fill} !important` : '')};
    stroke: ${({ stroke }) => (stroke ? `${stroke} !important` : '')};
  }

  &:hover path,
  g {
    fill: ${({ hoverFill }) => (hoverFill ? `${hoverFill} !important` : '')};
    stroke: ${({ hoverStroke }) =>
      hoverStroke ? `${hoverStroke} !important` : ''};
  }
`;

Icon.propTypes = {
  SvgComponent: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  hoverFill: PropTypes.string,
  hoverStroke: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  testId: PropTypes.string,
};

Icon.defaultProps = {
  width: undefined,
  height: undefined,
  fill: '',
  stroke: '',
  hoverFill: '',
  hoverStroke: '',
  className: '',
  onClick: null,
  style: {},
  testId: '',
};

export default Icon;
